import { AppDispatch } from "../../../app/store";
import {
  getConversationAttachmentUploadUrl,
  uploadConversationAttachmentToS3,
} from "../messagingApi";
import { patchMessageAttachment } from "../messagingSlice";
import { MessageAttachment } from "./types";

type Input = {
  conversationId: string;
  messageId: string;
  files: File[];
  attachments: MessageAttachment[];
};

export const uploadConversationAttachments = async (
  dispatch: AppDispatch,
  { conversationId, messageId, files, attachments }: Input,
): Promise<void> => {
  await Promise.all(
    files.map(async (file, index) => {
      const attachment = attachments[index];
      if (!attachment) return;

      try {
        const { url, pathspec } = await getConversationAttachmentUploadUrl({
          conversationId,
          messageId,
          filename: attachment.filename,
          size: file.size,
          contentType: attachment.contentType,
        });
        dispatch(
          patchMessageAttachment({
            conversationId,
            messageId,
            attachmentId: attachment.id,
            changes: { pathspec },
          }),
        );
        await uploadConversationAttachmentToS3(
          url,
          file,
          attachment.contentType,
        );
      } catch {
        dispatch(
          patchMessageAttachment({
            conversationId,
            messageId,
            attachmentId: attachment.id,
            changes: { status: "rejected" },
          }),
        );
      }
    }),
  );
};
